import React from 'react';
import { Text } from 'library';
import { styled, Grid } from '@mui/material';
import { ExplanatoryCredentialPill } from '../ExplanatoryCredentialPill';

export function BaseCredentials() {
    return (
        <Grid container style={{ marginTop: 3 }}>
            <Grid container item xs={12}>
                <Text variant="body2">• 1 year of verified experience in a licensed childcare center</Text>
            </Grid>
            <Grid container item xs={12}>
                <Text variant="body2">• Cleared background check</Text>
            </Grid>
            <Grid container item xs={12}>
                <Text variant="body2">• Verified high school education</Text>
            </Grid>
            <Grid container item xs={12}>
                <Text variant="body2">• Completed medical and emergency information forms</Text>
            </Grid>
            <ExplanatoryCredentialPill
                label="Forms as Required by NC Department of Health and Human Services >"
                title={
                    <Hover>
                        <Text variant="caption" bold>
                            Required Documents
                        </Text>
                        <Text variant="caption">- Application for Employment</Text>
                        <Text variant="caption">- Staff Health Assessment/Medical Report</Text>
                        <Text variant="caption">- TB Screening Form</Text>
                        <Text variant="caption">- Emergency Information on Staff</Text>
                        <Text variant="caption">- Health Questionnaire - Child Care Centers</Text>
                        <Text variant="caption" bold>
                            Trainings on state timeline
                        </Text>
                        <Text variant="caption">- ITS-SIDS</Text>
                        <Text variant="caption">- Health and Safety Training</Text>
                        <Text variant="caption">- Child Maltreatment Training</Text>
                        <Text variant="caption">- First Aid/CPR Training</Text>
                    </Hover>
                }
            />
        </Grid>
    );
}

const Hover = styled('div')({
    padding: 5,
});
